import { AsyncActionHandler } from 'action-handler';
import { defaultError } from 'config';
import { handleCommsError } from 'action-utils';

import {
  syncInstalledApps,
  fetchDeviceInfo,
  notifyAppInstallProgress,
  setCurrentlySyncing,
  triggerError,
  setConnectionStatus,
  initializeOptimizely
} from 'actions/gallery';

import { fetchFeaturesAndUser } from 'actions/registry';

const handleProgress = (dispatch, apps) =>
  dispatch(notifyAppInstallProgress({ apps }));

export default new AsyncActionHandler({
  name: 'app_setup',
  handler: () => async (dispatch, getState) => {
    window.__webview_comms__.onNotify(
      'app-install-progress',
      ({ apps = [] } = {}) => {
        handleProgress(
          dispatch,
          apps.map(({ appId, installProgress }) => ({
            appId: appId && appId.toLowerCase(),
            progress: installProgress
          }))
        );
      }
    );

    window.__webview_comms__.onNotify(
      'app-sync-progress',
      ({ appIds = [], progress } = {}) => {
        handleProgress(
          dispatch,
          appIds.map((appId) => ({
            appId: appId && appId.toLowerCase(),
            progress
          }))
        );
      }
    );

    window.__webview_comms__.onNotify(
      'app-install-completion',
      async (data) => {
        let error;
        if (data && data.error) {
          error = data.error;
        }

        // Always a good opportunity to fetch installed apps
        await dispatch(syncInstalledApps({ force: true }));

        dispatch(setCurrentlySyncing({ syncing: false, wifi: false }));

        if (typeof error === 'string') {
          handleCommsError(dispatch, 'app-install-completion', error);
        }
      }
    );

    // @todo remove "app-install-failure", replaced by "app-install-completion"
    window.__webview_comms__.onNotify('app-install-failure', () => {
      dispatch(setCurrentlySyncing({ syncing: false, wifi: false }));

      handleCommsError(dispatch, 'app-install-failure', defaultError);
    });

    window.__webview_comms__.onNotify(
      'device-connection-status',
      ({ connected } = {}) => {
        let {
          connectionStatus: { shownError }
        } = getState().gallery;

        if (!connected && !shownError) {
          handleCommsError(
            dispatch,
            'device-connection-status',
            'disconnected'
          );
          shownError = true;
        } else if (connected && shownError) {
          dispatch(triggerError()); // Dismiss error
          shownError = false;
        }

        dispatch(setConnectionStatus({ connected, shownError }));
      }
    );

    await dispatch(fetchDeviceInfo());
    await dispatch(fetchFeaturesAndUser());
    await dispatch(initializeOptimizely());
  }
});
